import { type ComponentType, createElement, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { AppLayoutClient } from '@/components/AppLayoutClient';
import { LoadingFallback } from '@/components/LoadingFallback';
import { Toaster } from '@/components/ui/sonner';

import { initI18n, transformLocales } from '@/helpers/client';

import { CLIENT_APP_LOCALES_LIST } from '@/constants';

import { QueryProvider } from '@/providers';

import * as clientLocalization from '@/client_localization';

import * as LazyPages from '@/pages/client/lazy';

export const renderClientLayout = (
  renderContainer = document.getElementById('page-root'),
  pageContainer = document.getElementById('page-content'),
) => {
  const { component_name, layout_name, layout_data, ...pageProps } = JSON.parse(
    pageContainer?.getAttribute('data') || '{}',
  );

  const mainInfo = document.getElementById('main-info');
  if (!mainInfo) {
    console.error('main-info element not found');
    return;
  }

  const commonData = JSON.parse(mainInfo.getAttribute('data') || '{}');

  const locales = transformLocales(
    [
      clientLocalization.COMMON,
      clientLocalization.validation,
      clientLocalization[component_name as keyof typeof clientLocalization],
    ],
    CLIENT_APP_LOCALES_LIST,
  );

  initI18n(locales, commonData.locale);

  const LazyClientPage = (
    LazyPages as unknown as Record<
      string,
      ComponentType<Record<string, unknown>>
    >
  )[component_name];

  if (!LazyClientPage) {
    console.error(`Page component "${component_name}" not found in lazy pages`);
    return;
  }

  createRoot(renderContainer!).render(
    <QueryProvider>
      <AppLayoutClient
        layout={layout_name}
        layout_data={layout_data}
        {...commonData.data}
      >
        <Suspense fallback={<LoadingFallback className="flex-1" />}>
          {createElement(LazyClientPage, pageProps)}
        </Suspense>
        <Toaster />
      </AppLayoutClient>
    </QueryProvider>,
  );
};
